export function renderPreviousButton(paginationInfo, translationsData) {
    if (paginationInfo.currentPage !== 1) {
        return `
        <button class="flex items-center gap-1 cursor-pointer flex-shrink-0 pagination-js-search-previous" aria-label="Go to previous page" data-page-target="${paginationInfo.currentPage - 1}">
            <svg class="h-6 w-3 rotate-180 fill-green-600"
                width="8"
                height="16"
                viewBox="0 0 8 16"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M0.355291 0.420947C0.242666 0.553514 0.153312 0.710979 0.0923468 0.884328C0.0313812 1.05768 0 1.2435 0 1.43118C0 1.61885 0.0313812 1.80468 0.0923468 1.97802C0.153312 2.15137 0.242666 2.30884 0.355291 2.44141L5.06911 8.00125L0.355291 13.5611C0.128132 13.829 0.000514428 14.1924 0.000514428 14.5713C0.000514428 14.9502 0.128132 15.3136 0.355291 15.5816C0.582451 15.8495 0.890546 16 1.2118 16C1.53305 16 1.84114 15.8495 2.0683 15.5816L7.64471 9.00431C7.75734 8.87175 7.84669 8.71428 7.90765 8.54093C7.96862 8.36758 8 8.18176 8 7.99408C8 7.80641 7.96862 7.62058 7.90765 7.44724C7.84669 7.27389 7.75734 7.11642 7.64471 6.98385L2.0683 0.406617C1.60664 -0.137904 0.829104 -0.137904 0.355291 0.420947Z"></path>
            </svg>
            <span class="sr-only md:not-sr-only">${translationsData["MetadataCatalogue.SearchResults.Prev"]}</span>
        </button>
        `;
    } else {
        return "";
    }
}

export function renderPaginationOptions(paginationInfo) {
    
    let navigationPages = "";
    if (paginationInfo.pages != null) {

        paginationInfo.pages.forEach(page => {
            navigationPages += `
            <li class="pagination__li">
                ${page !== paginationInfo.currentPage ? `
                <button class="flex h-7 w-7 items-center justify-center rounded-full hover:bg-green-200 pagination-js-search cursor-pointer"
                    aria-label="Go to page @pg"
                    data-page-target="${page}">
                    ${page}
                </button>
                ` : `
                <button class="flex h-7 w-7 items-center justify-center rounded-full bg-green-600 text-white"
                    aria-current="true"
                    aria-label="Current page, page @pg"
                    data-page-target="${page}">
                    ${page}
                </button>
                `}
            </li>
            `;
        })
        
    }
    
    return navigationPages;
}

export function renderNextButton(paginationInfo, translationsData) {
    if (paginationInfo.currentPage !== paginationInfo.totalPages) {

        return`
        <button class="flex items-center gap-1 flex-shrink-0 cursor-pointer pagination-js-search-next min-w-[1.5rem] justify-center" aria-label="Go to next page" data-page-target="${paginationInfo.currentPage + 1}">
            <span class="sr-only md:not-sr-only">${translationsData["MetadataCatalogue.SearchResults.Next"]}</span>
            <svg class="h-6 w-3 fill-green-600"
                width="8"
                height="16"
                viewBox="0 0 8 16"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M0.355291 0.420947C0.242666 0.553514 0.153312 0.710979 0.0923468 0.884328C0.0313812 1.05768 0 1.2435 0 1.43118C0 1.61885 0.0313812 1.80468 0.0923468 1.97802C0.153312 2.15137 0.242666 2.30884 0.355291 2.44141L5.06911 8.00125L0.355291 13.5611C0.128132 13.829 0.000514428 14.1924 0.000514428 14.5713C0.000514428 14.9502 0.128132 15.3136 0.355291 15.5816C0.582451 15.8495 0.890546 16 1.2118 16C1.53305 16 1.84114 15.8495 2.0683 15.5816L7.64471 9.00431C7.75734 8.87175 7.84669 8.71428 7.90765 8.54093C7.96862 8.36758 8 8.18176 8 7.99408C8 7.80641 7.96862 7.62058 7.90765 7.44724C7.84669 7.27389 7.75734 7.11642 7.64471 6.98385L2.0683 0.406617C1.60664 -0.137904 0.829104 -0.137904 0.355291 0.420947Z"></path>
            </svg>
        </button>
        `;

    }else{

        return "";
    }
}